// 项目协议类路由

// 签名页面
const Signature = r => require.ensure(
  [],
  () => r(require('@/components/bloom-pact/signature.vue')),
  'BloomPact'
)

// 协议书首页
const PactIndex = r => require.ensure(
  [],
  () => r(require('@/components/bloom-pact/pact-index.vue')),
  'BloomPact'
)

// 协议书页面
const ProjectAgreement = r => require.ensure(
  [],
  () => r(require('@/components/bloom-pact/project-agreement.vue')),
  'BloomPact'
)

// 监护人信息
const FiduciaryInfo = r => require.ensure(
  [],
  () => r(require('@/components/bloom-pact/fiduciary-info.vue')),
  'BloomPact'
)

// 监护人信息提交成功
const Success = r => require.ensure(
  [],
  () => r(require('@/components/bloom-pact/success.vue')),
  'BloomPact'
)

export default [
  // 签名页面
  {
    path: '/BloomPact/Signature',
    name: 'PactSignature',
    component: Signature,
    meta: {
      title: ''
    }
  },
  // 协议书首页
  {
    path: '/BloomPact/PactIndex',
    name: 'PactIndex',
    component: PactIndex,
    meta: {
      title: ''
    }
  },
  // 协议书页面
  {
    path: '/BloomPact/ProjectAgreement',
    name: 'PactProjectAgreement',
    component: ProjectAgreement,
    meta: {
      title: ''
    }
  },
  // 监护人信息
  {
    path: '/BloomPact/FiduciaryInfo',
    name: 'PactFiduciaryInfo',
    component: FiduciaryInfo,
    meta: {
      title: ''
    }
  },
  // 监护人信息提交成功
  {
    path: '/BloomPact/Success',
    name: 'PactSuccess',
    component: Success,
    meta: {
      title: ''
    }
  }
  
]



// WEBPACK FOOTER //
// ./src/router/sub-route/bloom-pact.js